<template>
  <div class="" v-on:keyup.f9="compile">
    <nav class="navbar navbar-inverse navbar-sm">
      <div class="container-fluid">
        <div class="navbar-header">
          <a class="navbar-brand" href="#"><icon name="user-secret"></icon> {{ agentType.name }} ({{ agentType.agentNames.length }})</a>
        </div>

        <ul class="nav navbar-nav">
          <li><a href="#" @click="compile" v-shortkey="['f9']" @shortkey="compile()"><icon name="gears"></icon> Compile</a></li>
        </ul>

        <ul class="nav navbar-nav navbar-right">
          <li :class="{ active: rightPanel=='CALLSTACK'}" v-if="activeAgent" @click="toggleRightPanel('CALLSTACK')"><a href="#"><icon name="stack-overflow"></icon></a></li>
          <li :class="{ active: rightPanel=='MEMORY'}" v-if="activeAgent" @click="toggleRightPanel('MEMORY')"><a href="#"><icon name="database"></icon></a></li>
          <li :class="{ active: rightPanel=='INSTRUCTIONS'}" v-if="agentType.instructions" @click="toggleRightPanel('INSTRUCTIONS')"><a href="#"><icon name="th-list"></icon></a></li>
          <li :class="{ active: rightPanel=='CONSOLE' }" @click="toggleRightPanel('CONSOLE')"><a href="#"><icon name="list-alt"></icon></a></li>
          <li :class="{ active: rightPanel=='API' }" @click="toggleRightPanel('API')"><a href="#"><icon name="book"></icon> Help</a></li>
        </ul>
      </div>
    </nav>

    <!-- Agent names -->
    <div class="agent-bar">
      <span v-for="agentName in agentType.agentNames" :class="{ active: activeAgent && activeAgent.name == agentName }" @click="agentNameClick(agentName)"><icon name="user-secret"></icon> {{ agentName }}</span>
    </div>

    <!-- AceEditor -->
    <div style="overflow:hidden;position:relative;">
      <aceEditor ref="aceEditor" width="100%" height="200px" 
        :initialSource="agentType.definition.solution" @change="editorChange" @gutterClick="toggleBreakpoint"></aceEditor>

      <!-- Right panel -->
      <div class="right-panel" v-show="rightPanel != null">
        
          <!-- Instructions -->
          <div v-if="rightPanel=='INSTRUCTIONS'">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th>#</th><th>Instruction</th><th>Parameters</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(instruction, index) in agentType.instructions" @click="selectInstruction(instruction)" :class="{ info: selectedInstruction == instruction, warning: instruction.breakpoint }">
                  <td>{{ index }}</td><td>{{ instruction.id }}</td><td>{{ instruction.params }}</td>
                </tr>
            </tbody>
            </table>
          </div>

          <!-- API Help -->
          <div v-show="rightPanel=='API'" v-if="agentType.definition.api" class="doc-panel">
            <tabs nav-style="pills">
              <tab :header="api.name" v-for="api in agentType.definition.api">
                  <resourceTemplate :resource="api.doc"></resourceTemplate>
              </tab>
            </tabs>
          </div>

          <!-- Console -->
          <console v-show="rightPanel=='CONSOLE'" :keys="agentType.agentNames" slim=true></console>

          <!-- Callstack -->
          <div v-if="activeAgent && rightPanel=='CALLSTACK'">
              <h4>Call stack</h4>
              <table class="table table-bordered table-striped table-condensed">
                  <thead>
                    <tr>
                      <th>#</th><th>Function call</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(instruction, index) in activeAgent.executor.memory.callStack.array" @click="selectInstruction(instruction)" :class="{ info: selectedInstruction == instruction, warning: instruction.breakpoint }">
                      <td>{{ index }}</td><td>{{ instruction.params.name }}</td>
                    </tr>
                </tbody>
              </table>
              <h4>Main value stack</h4>
              <table class="table table-bordered table-striped table-condensed">
                  <thead>
                    <tr>
                      <th>#</th><th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in activeAgent.executor.stack.array">
                      <td>{{ index }}</td><td><objectView :value="activeAgent.executor.stack.array[index]" /></td>
                    </tr>
                </tbody>
              </table>
          </div>

          <!-- Memory -->
          <div v-if="activeAgent && rightPanel=='MEMORY'">
            <h3>Global scope</h3>
              <table class="table table-bordered table-striped table-condensed">
                  <thead>
                    <tr>
                      <th>Identifier</th><th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="key in Object.keys(activeAgent.executor.memory.globalScope())">
                      <td>{{ key }}</td><td><objectView :value="activeAgent.executor.memory.loadGlobal(key)" /> }}</td>
                    </tr>
                </tbody>
              </table>
              <h3>Local scope</h3>
              <table class="table table-bordered table-striped table-condensed">
                  <thead>
                    <tr>
                      <th>Identifier</th><th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="key in Object.keys(activeAgent.executor.memory.localScope())">
                      <td>{{ key }}</td><td><objectView :value="activeAgent.executor.memory.loadLocal(key)" /></td>
                    </tr>
                </tbody>
              </table>
          </div>

        </div>
    </div>

    <!-- status bar -->
    <div class="status-bar">
      <icon :name="agentType.state.icon"></icon> {{ agentType.state.message }}
    </div>

  </div>
</template>

<script>
import aceEditor from 'components/workbench/editor/AceEditor'
import resourceTemplate from '../../utils/ResourceTemplate';
import console from 'components/console/Console';
import objectView from 'vue-object-view';

export default {
  name: 'codearea',
  data() {
    return {
      selectedInstruction: null, /* clicked/highlighted instruction index */

      activeAgent: null,

      rightPanel: null
    }
  },
  props: ["agentType"],
  components: {
    aceEditor,
    resourceTemplate,
    console,
    objectView
  },
  mounted() {
      this.init();
  },
  watch: {
      agentType() {
          this.init();
      }
  },
  methods:{

        init() {
          this.lowlightAgent();
          this.$refs.aceEditor.removeMarkers();
          this.$refs.aceEditor.removeBreakpoints();
          this.agentType.setCodearea(this);
          this.agentType.stateNotCompiled();
        },

        getSource() {
            return this.$refs.aceEditor.getSource();
        },

        setError(e) {
            this.$refs.aceEditor.setError(e);
        },

        compile() {
            this.agentType.compile();
        },

        // on editor changed event handler
        editorChange(content) {
            this.agentType.stateNotCompiled();
            this.agentType.removeBreakpoints();
            this.unselectInstruction();
            this.showInstructions = false;
            this.$refs.aceEditor.removeMarkers();
        },

        toggleBreakpoint(row) {
            this.agentType.toggleBreakpoint(row);
        },

        selectInstruction(instruction) {
          this.unselectInstruction();
          if (instruction.location) {
            this.$refs.aceEditor.markInstruction(instruction.location);
            this.selectedInstruction = instruction;
          }
        },
        unselectInstruction() {
          this.selectedInstruction = null;
          this.$refs.aceEditor.unmarkInstruction();
        },

        focus() {
            this.$emit('focus');
        },

        highlightAgent(agent, instruction) {
          this.selectInstruction(instruction);
          this.activeAgent = agent;
          this.focus();
        },

        lowlightAgent() {
          this.unselectInstruction();
          this.activeAgent = null;
        },

        agentNameClick(agentName) {
            let agent = this.agentType.agents[agentName];
            if (agent) {
              agent.highlight();
            }
        },

        /*
         * Right panel
         */
         toggleRightPanel(panel) {
            if (this.rightPanel == panel) {
              this.rightPanel = null;
            } else {
              this.rightPanel = panel;
            }
         }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .right-panel {
    width:30%;
    position: absolute;
    height:100%;
    right:0px;
    top:0px;
    border-left: 2px solid #090909;
    border-right: 2px solid #090909;
    z-index: 100;
    overflow-y: auto;
    background-color: white;
  }
  .doc-panel {
    padding-left: 7px;
  }
  .navbar-sm {
    margin-bottom: 0px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  .status-bar {
    background-color: #222;
    border: 1px solid #090909;
    border-radius: 0px 0px 4px 4px;
    color: #F8F8F2;
    padding-left: 10px;
  }
  .agent-bar {
    background-color: #222;
    border-bottom: 1px solid #090909;
    color: gray;
    padding-left: 10px;
  }
  .agent-bar span {
    padding: 2px;
    cursor: pointer;
    margin-left: 5px;
  }
  .agent-bar .active {
    background-color: lightyellow;
    color: #222;
  }
</style>



// WEBPACK FOOTER //
// Codearea.vue?49494516